import React from 'react';
import { Modal } from '@vectord/components';

import { CreateSuperBatchAcademyTopicForm } from 'features/classCreation';

export default function CreateSuperBatchAcademyTopicModal({
  isOpen,
  handleClose,
  sbatGroup,
}) {
  return (
    <Modal
      isOpen={isOpen}
      size="large"
      className="p-b-xs"
      title="Add new batch"
      unMountOnClose
      onClose={handleClose}
    >
      <CreateSuperBatchAcademyTopicForm
        onSuccess={handleClose}
        sbatGroup={sbatGroup}
      />
    </Modal>
  );
}
